import React from 'react';

const TableAnticipoTheadFull = (props) => {
  return (
    <thead className="sticky top-0 z-10 bg-gray-100 text-sm uppercase text-gray-700">
      <tr>
        <th className="w-2"></th>
        <th
          scope="col"
          className="whitespace-nowrap px-2 text-left">
          Consecutivo
        </th>
        <th
          scope="col"
          className="whitespace-nowrap px-2 text-left">
          Solicitud
        </th>
        <th
          scope="col"
          className="px-2 text-left">
          Cliente
        </th>
        <th
          scope="col"
          className="px-2 text-left">
          Origen - Destino
        </th>
        <th
          scope="col"
          className="px-2 text-left">
          Placa
        </th>
        <th
          scope="col"
          className="px-2 text-left">
          Beneficiario
        </th>
        <th
          scope="col"
          className="px-2 text-right">
          Valor
        </th>
        <th
          scope="col"
          className="whitespace-nowrap px-2 text-left">
          Fecha
        </th>
        <th
          scope="col"
          className="px-2 text-left">
          Observaciones
        </th>
        <th
          scope="col"
          className="px-2 text-center">
          Siesa
        </th>
      </tr>
    </thead>
  );
};

export default TableAnticipoTheadFull;
